<template>
    <!-- <HeaderMenu ></HeaderMenu> -->
    <div class="container">
      <div class="row pt-2 text-start mb-2">
          <div class="col-6">
              <h5>
                <span class="badge rounded-pill border text-dark p-2 px-3">
                <b>Users : รายชื่อผู้ใช้งาน</b>
                </span>
              </h5>
          </div>
          <div class="col-6">
              <button type="button" class="btn btn-primary float-sm-end " data-bs-toggle="modal" data-bs-target="#UserModal" @click="newRecord()" style="width:160px;">New</button>
          </div>
      </div>
      <div class="row ">
        <div class="col-sm">
            <table id="myUsersTable" class="table table-sm table-hover table-striped table-bordered" style="width: 100%;">
                <thead class="text-white" style="background:black">
                <tr>
                    <!-- <th >รหัสคลินิก</th> -->
                    <th style="width:60px;">คำสั่ง</th>
                    <th style="width:80px;">Logon User</th>
                    <th style="width:200px;">ชื่อ-นามสกุล เลขที่ ทน.</th>
                    <th style="width:80px;">ตำแหน่ง</th>
                    <th style="width:150px;">สาขา</th>
                    <th style="width:100px;">แผนก</th>
                    <th style="width:60px;">รหัสผ่าน</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="item in datalists" :key="item.branchid" v-bind:data-id="item.branchid" @click="tableChanged(item)">
                    <!-- <td class="text-start">{{ item.ReqClinicCode }}</td> -->
                    <td  >
                      <button type="button" class="btn btn-primary btn-sm mx-1 py-0" id="Edit" data-bs-toggle="modal" data-bs-target="#UserModal">Edit</button>
                      <button hidden class="btn btn-danger btn-sm py-0" id="Delete" @click="cancelRecord(item)">Del</button>
                    </td>
                    <td class="text-start">{{ item.Username }}</td>
                    <td class="text-start">{{ item.OfficialName }}</td>
                    <td class="text-start">{{ item.Position }}</td>
                    <td class="text-start">{{ item.BranchName }}</td>
                    <td class="text-start">{{ item.UsergroupName }}</td>
                    <td  >
                      <button class="btn btn-danger btn-sm py-0" id="ResetPassword" @click="ResetPassword(item)">Reset</button>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>

        <!-- Modal Form -->
        <div id="UserModal" class="modal" tabindex="-1">
          <div class="modal-dialog">
            <div class="modal-content" >
              <div class="modal-header">
                <h5 class="modal-title">Users : ป้อนชื่อผู้ใช้งาน</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
              </div>
              <div class="modal-body">
                <form id="fmUsers" @submit.prevent="" >
                    <input type="text" hidden class="form-control" id="CorpID" placeholder="" name="CorpID" v-model="globalCorpID" >
                    <input type="text" hidden class="form-control" id="action" placeholder="" name="action" v-model="action" >
                    <input type="text" hidden class="form-control" placeholder="" name="UserID" v-model="curRecord.UserID" >
                    <div class="row mb-1">
                        <div class="col-sm text-start">
                            <div class="input-group input-group-sm">
                              <span class="input-group-text" style="width:150px;">User Name. *</span>
                              <input type="text" class="form-control form-control-sm" name="Username" v-model="curRecord.Username">
                            </div>
                        </div>
                    </div>
                    <div class="row mb-1">
                        <div class="col-sm text-start">
                            <div class="input-group input-group-sm">
                              <span class="input-group-text" style="width:150px;">ชื่อ-นามสกุล ทน.*</span>
                              <input type="text" class="form-control form-control-sm" name="OfficialName" v-model="curRecord.OfficialName">
                            </div>
                        </div>
                    </div>
                    <div class="row mb-1">
                        <div class="col-sm text-start">
                            <div class="input-group input-group-sm">
                              <span class="input-group-text" style="width:150px;">ตำแหน่ง</span>
                              <input type="text" class="form-control form-control-sm" name="Position" v-model="curRecord.Position">
                            </div>
                        </div>
                    </div>
                    <div class="row mb-1">
                        <div class="col text-start">
                            <!-- แผนก -->
                            <div class="input-group input-group-sm">
                                <div class="input-group" title="ระบุแผนกเพื่อกำหนดสิทธิการเข้าใช้งาน">
                                    <span class="input-group-text" style="width:150px;">แผนก* :</span>
                                    <select class="form-select form-select-sm" ref="UsergroupID" id="UsergroupID" name="UsergroupID" v-model="curRecord.UsergroupID" >
                                        <option disabled value="">Please select one</option>
                                        <option v-for="item in dataUsergrouplists" :key="item.UsergroupID" :value="item.UsergroupID">{{ item.UsergroupName }}</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>
                    <br>
                    <div class="row mb-1">
                        <div class="col text-start">
                            <!-- สาขาแล็บ -->
                            <div class="input-group input-group-sm">
                                <div class="input-group-prepend">
                                    <span class="input-group-text" style="width:150px;">สาขา* :</span>
                                </div>
                                <select class="form-select form-select-sm" ref="BranchID" id="BranchID" name="BranchID" v-model="curRecord.BranchID" >
                                    <option disabled value="">Please select one</option>
                                    <option v-for="item in dataBranchlists" :key="item.BranchID" :value="item.BranchID">{{ item.BranchName }}</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <br>
                </form>
              </div>

              <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                <button type="button" class="btn btn-primary" data-bs-dismiss="modal" @click="saveData()">Save changes</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
// import axios from 'axios'
// import { MyApiClient } from '../myjs/my-api-client.js'
// Bootstrap and jQuery libraries
import 'bootstrap/dist/css/bootstrap.min.css'
import 'jquery/dist/jquery.min.js'
// Datatable Modules
import 'datatables.net-dt/js/dataTables.dataTables'
import 'datatables.net-dt/css/jquery.dataTables.min.css'
import $ from 'jquery'
import Swal from 'sweetalert2'
import { inject, ref } from 'vue'

export default {
  setup () {
    var globalCorpID = inject('corpID', ref(-1))
    var globalCorpName = inject('corpName', ref(''))
    var globalBranchID = inject('branchID', ref(-1))
    var globalUserID = inject('userID', ref(-1))
    var globalUserName = inject('userName', ref(''))
    var globalUserOfficialName = inject('userOfficialName', ref(''))
    var globalUserPosition = inject('userPosition', ref(''))
    return {
      globalCorpID, globalCorpName, globalBranchID, globalUserID, globalUserName, globalUserOfficialName, globalUserPosition
    }
  },
  name: 'SettingUsers1View',
  components: {

  },
  data () {
    return {
      curRecord: {},
      action: 'new'
    }
  },
  props: ['datalists', 'dataBranchlists', 'dataUsergrouplists'],
  mounted () {

  },
  methods: {
    ResetPassword (item) {
      var self = this
      Swal.fire({
        title: item.Username,
        text: 'คุณแน่ใจหรือไม่...ที่จะรีเซตรหัสผ่าน? \n รหัสผ่านจะรีเซตเป็นชื่อผู้ใช้งาน',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'ใช่! แน่ใจ',
        cancelButtonText: 'ยกเลิก'
      }).then((result) => {
        if (result.isConfirmed) {
          $.ajax({
            type: 'POST',
            url: this.http_baseurl + 'setdata/user_reset.php',
            data: { id: item.UserID, Username: item.Username }
          }).done(function () {
            Swal.fire({
              text: 'รีเซตรหัสผ่านเรียบร้อย..แจ้งผู้ใช้งานให้เปลี่ยนรหัสผ่านทันที',
              icon: 'success',
              confirmButtonText: 'ตกลง'
            }).then((result) => {
              self.getData()
            })
          })
        }
      })
    },
    backPageAfterSave () {
      this.$emit('onBackPageAfterSaveEvent')
    },
    cancelRecord (item) {
      var self = this
      Swal.fire({
        title: item.BranchName,
        text: 'คุณแน่ใจหรือไม่...ที่จะลบข้อมูล?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'ใช่! แน่ใจ',
        cancelButtonText: 'ยกเลิก'
      }).then((result) => {
        if (result.isConfirmed) {
          $.ajax({
            type: 'POST',
            url: this.http_baseurl + 'setdata/delete_branch.php',
            // url: 'http://localhost/vmedlab/src/service/setdata/cancel_branch.php',
            // url: 'http://www.labsmartsoft.com/vmedlab/service/' + 'setdata/cancel_branch.php',
            data: { id: item.BranchID }
          }).done(function () {
            Swal.fire({
              text: 'ข้อมูลของคุณถูกลบเรียบร้อย',
              icon: 'success',
              confirmButtonText: 'ตกลง'
            }).then((result) => {
              self.getData()
            })
          })
        }
      })
    },
    newRecord () {
      this.curRecord = {}
      this.action = 'new'
    },
    tableChanged (row) {
      var curRow = Object.assign({}, row)
      this.curRecord = curRow
      this.action = 'edit'
      // console.log(this.curRecord)
    },
    saveData () {
      var self = this
      // แปลงข้อมูลจากฟอร์ม
      var x = $('#fmUsers').serializeArray()
      var formData = {}
      $.each(x, function (i, field) {
        $.extend(formData, { [field.name]: field.value })
      })
      //   console.log(formData)
      // Insert/Update by call API
      $.ajax({
        type: 'POST',
        url: this.http_baseurl + 'setdata/insert_user.php',
        data: { request: JSON.stringify(formData) }
      })
        .done(function (resp) {
          Swal.fire({
            position: 'top-end',
            icon: 'success',
            title: 'บันทึกข้อมูลเสร็จเรียบร้อย',
            showConfirmButton: false,
            timer: 1500
          }).then(function (result) {
            // Refresh >> this component only
            // this.$refs.getData()
            self.backPageAfterSave()
            // location.reload()
            // this.$router.push('MClinics')
          })
        })
        .fail(function (resp) {
          // alert('Not Saved')
          Swal.fire({ icon: 'error', text: 'ไม่สามารถบันทึกข้อมูลได้' })
        })
    }
  }
}
</script>

<style>

</style>
